module.exports = __webpack_public_path__ + "img/incomplete.4d668271.png";